import './lib/storage-proxy';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BetterAuthProvider } from './context/BetterAuthContext';
import { AppErrorBoundary } from './components/AppErrorBoundary';

// Declare types for global custom helper
declare global {
  interface Window {
    dispatchVedicEvent?: (name: string, detail?: any) => void;
  }
}

// Global safe event dispatcher helper
if (typeof window !== 'undefined' && !window.dispatchVedicEvent) {
  window.dispatchVedicEvent = function (name: string, detail?: any) {
    if (typeof window === 'undefined') return;

    try {
      let event: any = null;

      if (typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        try {
          const customEvt = document.createEvent('CustomEvent');
          if (customEvt && typeof customEvt.initCustomEvent === 'function') {
            customEvt.initCustomEvent(name, true, true, detail);
            event = customEvt;
          }
        } catch (e) {
          // fallback
        }

        if (!event) {
          try {
            const genericEvt = document.createEvent('Event');
            if (genericEvt && typeof genericEvt.initEvent === 'function') {
              genericEvt.initEvent(name, true, true);
              (genericEvt as any).detail = detail;
              event = genericEvt;
            }
          } catch (e) {
            // fallback
          }
        }
      }

      if (event && typeof window.dispatchEvent === 'function') {
        try {
          window.dispatchEvent(event);
        } catch (e) {
          // silent catch
        }
      }
    } catch (e) {
      // silent catch
    }
  };
}
// Service Worker registration for PWA offline capability
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => console.log('⚡ [PWA] Service Worker registered:', reg.scope),
      (err) => console.warn('⚠️ [PWA] Service Worker registration failed:', err)
    );
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppErrorBoundary>
      <BetterAuthProvider>
        <App />
      </BetterAuthProvider>
    </AppErrorBoundary>
  </StrictMode>
);
